import refs from '../refsLite'
import { deleteDoc } from 'firebase/firestore/lite'

export async function deleteAccessRequest(accessRequestId) {
  await deleteDoc(refs.accessRequest(accessRequestId))
  return true
}
